<template>
  <div>
    <ranking-table
      :file="'asset/files/' + $route.query.name + '.json'"
      :modal="modal"
      :fields="fields"
      :backButton="false"
    />
  </div>
</template>

<script>
import RankingTable from '@/components/common/RankingTable2';
import _ from 'lodash';

export default {
  components: {
    RankingTable
  },
  props: {
    textElements: {
      type: Object,
      default: () => {}
    },
    variant: {
      type: String
    }
  },
  metaInfo() {
    return {
      meta: [
        {
          property: 'og:title',
          vmid: 'og-title',
          content: this.page.title
        },
        {
          property: 'og:description',
          vmid: 'og-description',
          content: this.page.subTitle
        }
      ]
    };
  },
  created() {},
  data() {
    return {
      content: [],
      page: {},
      modal: {}
    };
  },
  methods: {},
  computed: {
    fields() {
      if (this.$route.query.type == 'mainRanking')
        return [
          {
            key: 'Rank 2023',
            sortable: true,
            class: 'text-center'
          },
          {
            key: 'UNIVERSITY',
            sortable: true
          },
          { key: 'COUNTRY', sortable: true },
          {
            key: '2022 (top 200)',
            class: 'text-center'
          },
          {
            key: '2022-23 trend',
            class: 'text-center'
          }
        ];
      else if (this.$route.query.type == 'mainRanking2024')
        return [
          {
            key: 'UNIVERSITY',
            sortable: true
          },

          { key: 'COUNTRY', sortable: true },
          {
            key: 'RANK 2022/2023',
            sortable: true,
            class: 'text-center'
          },
          {
            key: 'RANK 2024',
            class: 'text-center'
          },
          {
            key: 'TREND',
            class: 'text-center'
          }
        ];
      else if (this.$route.query.type == 'mainRanking2020')
        return [
          {
            key: 'University',
            sortable: true
          },
          { key: 'Country', sortable: true },
          { key: '2019', sortable: true, class: 'text-center' },
          { key: '2020', sortable: true, class: 'text-center' }
        ];
      else if (this.$route.query.type == 'mainRanking2021')
        return [
          {
            key: 'University',
            sortable: true
          },
          { key: 'Country', sortable: true },
          { key: '2020', sortable: true, class: 'text-center' },
          { key: '2021', sortable: true, class: 'text-center' }
        ];
      else if (this.$route.query.type == 'mainRanking2022')
        return [
          {
            key: 'University',
            sortable: true
          },
          { key: 'Country', sortable: true },
          { key: 'Rank 2021', sortable: true, class: 'text-center' },
          { key: 'Rank 2022', sortable: true, class: 'text-center' }
        ];
      else if (this.$route.query.type == 'hubs')
        return [
          {
            key: 'Hub',
            sortable: true
          },
          {
            key: 'Rank',
            class: 'text-center'
          }
        ];
      else if (this.$route.query.type == 'bestofclass')
        return [
          {
            key: 'UNIVERSITY',
            sortable: true
          },
          {
            key: 'COUNTRY',
            sortable: true
          }
        ];
      else
        return [
          {
            key: 'UNIVERSITY',
            sortable: true
          },
          {
            key: 'COUNTRY',
            sortable: true
          },
          {
            key: 'RANK',
            label: 'RANK',
            class: 'text-center'
          }
        ];
    }
  }
};
</script>

<style lang="scss" scoped>
.blog-text table {
  margin-left: auto;
  margin-right: auto;
  background: black;
}
</style>
<style>
.blog-text table {
  margin-left: auto;
  margin-right: auto;
}

.blog-text table th {
  width: 200px;
  text-align: center;
}
</style>
